import React, { useMemo } from 'react'
import fetchHverfi from 'api/fetchHverfi'
import { useQuery } from 'react-query'

const useHverfi = (hverfi = null) => {
  const hverfin = require('data/hverfi').default
  const { data } = useQuery('hverfi', fetchHverfi)

  const res = useMemo(() => {
    const hverfid = hverfin[hverfi]

    if (hverfid && data) {
      const hverfiData = data.find((item) => item.key === hverfid.key)

      hverfid.afangar.map((afangi) => {
        afangi.takkamynd.list.map((item) => {
          const itemData = hverfiData.lodir.find((lod) => lod.slug === item.lod)

          item.seld = itemData?.seld
          item.i_auglysingu = itemData?.i_auglysingu
          item.i_birtingu = itemData?.i_birtingu

          return item
        })
      })

      if (!hverfiData.deiliskipulag) {
        hverfiData.deiliskipulag = {}
      }

      hverfid.data = hverfiData
    }

    return hverfid
  }, [hverfin, hverfi, data])

  return res
}

export default useHverfi
